import differenceInYears from "date-fns/differenceInYears";
import differenceInDays from "date-fns/differenceInDays";
import { cn } from "../../utils/class-names";
import { Link, UnstyledLink } from "../link";
import { LINKS, Percent } from "@silo/types";
import { ExternalLinkIcon } from "../../icons";

interface TrustSignalsProps {
  className?: string;
  deploymentDate: Date;
}

export function TrustSignals({
  className,
  deploymentDate,
}: TrustSignalsProps): JSX.Element {
  const currentDate = new Date();
  const years = differenceInYears(currentDate, deploymentDate);
  const days = differenceInDays(currentDate, deploymentDate) - years * 365;
  const formattedDuration = years > 0 ? `${years}y ${days}d` : `${days}d`;

  return (
    <ul
      className={cn(
        "bg-shale-800 rounded-lg p-5 md:py-[14px] font-medium flex flex-col gap-5 md:flex-row md:divide-x divide-shale-700",
        className
      )}
    >
      <li className="flex gap-2.5">
        <span className="font-mono">{formattedDuration}</span>
        <span className="font-normal text-shale-200">since deployment</span>
      </li>
      <li className="md:pl-5">Non-upgradable</li>
      <li className="md:pl-5">
        <UnstyledLink
          external
          href={LINKS.SILOPEDIA.AUDITED}
          className="flex gap-2.5 items-center"
        >
          <span className="text-white">Audited & formally verified</span>
          <ExternalLinkIcon className="w-4 h-4 text-shale-400" />
        </UnstyledLink>
      </li>
    </ul>
  );
}
